enum WaitReasons {
  NO_AGENTS_WITH_MATCHED_RESTRICTIONS = 'There are no compatible agents which can run this build and match the specified restrictions',
  NO_COMPATIBLE_AGENTS_AVAILABLE = 'There are no compatible agents which can run this build',
  NO_ENABLED_COMPATIBLE_AGENTS = 'There are no enabled compatible agents which can run this build',
  WAITING_FOR_CLOUD_AGENT = 'Waiting for starting agent',
}
const waitReasonsWithWarning: string[] = [
  WaitReasons.NO_AGENTS_WITH_MATCHED_RESTRICTIONS,
  WaitReasons.NO_COMPATIBLE_AGENTS_AVAILABLE,
  WaitReasons.NO_ENABLED_COMPATIBLE_AGENTS,
]
export function isWaitReasonWithWarning(waitReason: string | null | undefined): boolean {
  return waitReason != null && waitReasonsWithWarning.includes(waitReason)
}
export function isWaitReasonWithAnimation(waitReason: string | null | undefined): boolean {
  return waitReason === WaitReasons.WAITING_FOR_CLOUD_AGENT
}
